<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2021-04-23 09:39:29
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-06-02 13:53:25
-->
<template>
  <div class="accessFailed">
    <div class="imgBox">
      <img src="@/assets/images/404.png" alt="" />
      <p>未配置产品权限，请联系您的客户经理咨询详情</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'accessFailed',
  data() {
    return {};
  },
};
</script>
<style scoped>
.accessFailed {
  widows: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imgBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 4.5rem;
}
.imgBox p {
  font-size: 0.12rem;
  color: #999;
}
.imgBox img {
  width: 45%;
}
</style>
